<template>
  <!--
    	作者：zct
    	时间：2021-10-08
    	描述：单位-添加单位
    -->
  <div class="product-add">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="80px">
      <!--添加单位-->
      <div class="common-form">添加单位</div>

      <el-form-item label="单位名称" prop="unit_name" :rules="[{required: true,message: ' '}]">
        <el-input v-model="form.unit_name" placeholder="请输入单位名称" class="max-w460"></el-input>
      </el-form-item>
      <!-- <el-form-item label="单位logo">
        <el-row>
          <el-button icon="el-icon-picture-outline" @click="openUpload">选择图片</el-button>
          <div v-if="form.logo_image_id!=''" class="img">
            <img :src="file_path" width="100" height="100" />
          </div>
        </el-row>
      </el-form-item> -->
      <div style="padding: 10px 0px;">
        <el-button size="small" class="el-icon-circle-plus" @click="onAddGroup">添加团队</el-button>
      </div>
      <div v-for="(ddd,index) in group" :key="index" >

          <el-form-item label="团队名称">
              <el-input style="width:180px" v-model="ddd.unit_group_name" placeholder="请输入团队名称" autocomplete="off" required prop="option">

              </el-input>
              <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteOption(index)" v-if="index > 0"><i class="el-icon-close"></i></a>
          </el-form-item>
          <!-- <el-form-item label="队长ID" >
             <el-input type="text" v-model="ddd.user_id" autocomplete="off" style="width:180px"  readonly="">
             <el-button slot="append" type="primary" icon="el-icon-user-solid" @click="openUserDialog(index)">选择用户</el-button>
             </el-input>

           </el-form-item> -->
      </div>
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
    <!--上传图片组件-->
    <Upload v-if="isupload" :isupload="isupload" :type="type" @returnImgs="returnImgsFunc">上传图片</Upload>
    <!--用户选择-->
    <GetUser :is_open="open_user" @close="closeUserDialog"></GetUser>
  </div>
</template>

<script>

  import unitApi from '@/api/unit.js';
  import Upload from '@/components/file/Upload';
  import GetUser from '@/components/user/GetUser.vue';
  export default {
    components: {

      Upload,
      GetUser
    },
    data() {
      return {
        /*切换菜单*/
        // activeIndex: '1',
        /*form表单数据*/
        form: {
          unit_name: '',
        },
        file_path: '',
        /*省市区*/
        areaList: [],
        /*是否上传图片*/
        isupload: false,
        loading: false,
        position:[],
        open_user:false,
        userList:[],
        group:[],
        index:0
      };
    },
    created() {
      /*引用的select_region 初始化*/
      this.getData();
    },

    methods: {
      getData(){

      },
      /*添加用户*/
      onSubmit() {
        let self = this;
        let form = self.form;
        if(self.group){
          let stat = false;
          self.group.forEach((item,index)=>{

            if(item.unit_group_name == ''){
              stat = true;
            }
          })
          if(stat){
            self.$message({
              message: "团队名称不能为空",
              type: 'error'
            });
            return false;
          }
          form.group = JSON.stringify(self.group);
        }


        self.$refs.form.validate((valid) => {
          if (valid) {
            self.loading = true;
            unitApi.addUnit(form, true)
              .then(data => {
                self.loading = false;
                if (data.code == 1) {
                  self.$message({
                    message: '恭喜你，添加成功',
                    type: 'success'
                  });
                  self.$router.push('/unit/unit/index');
                } else {
                  self.loading = false;
                }
              })
              .catch(error => {
                self.loading = false;
              });
          }
        });


      },

      /*上传*/
      openUpload(e) {
        this.type = e;
        this.isupload = true;
      },

      /*获取图片*/
      returnImgsFunc(e) {
        if (e != null && e.length > 0) {
          this.file_path = e[0].file_path;
          this.form.logo_image_id = e[0].file_id;
        }
        this.isupload = false;
      },



      /*取消*/
      cancelFunc() {
        this.$router.back(-1);
      },
      /*打开用户弹窗*/
      openUserDialog(index) {
        this.index = index;
        this.open_user = true;
      },
      /*关闭用户弹窗*/
      closeUserDialog(e) {
        if (e.type != 'error') {
          console.log(e,this.index)
          this.group[this.index].user_id = e.params[0].user_id;
          // this.user = e.params[0];
          // this.form.put_people_id = e.params[0].user_id;
        }
        this.open_user = false;
      },
      /*添加团队*/
      onAddGroup(){
        let self = this;
        self.group.push({'unit_group_name':''})
      },
      /*删除团队*/
      deleteOption(index) {

        this.group.splice(index, 1);
      },
    }

  };
</script>

<style lang="scss" scoped>
  .basic-setting-content {}

  .product-add {
    padding-bottom: 50px;
  }

  .img {
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/views/unit/unit/add.vue